import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import useQuery from "../../../../../../ui/QueryTable/useQuery";
import {makeStyles} from "@material-ui/core/styles";
import QueryTable from "../../../../../../ui/QueryTable";
import MasterClassDrawer from "../../components/MasterClassDrawer";
import useMasterClasses from "./useMasterClasses";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import AddMasterClassModal from "../../components/AddMasterClassModal";
import AddButton from "../../../../../../ui/AddButton";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "/work/app/manage/resources/programs"
  },
  {
    label: "Мои мастер-классы",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const MasterClassList = () => {

  const {
    isCreatingMasterClass,
    isDeletingMasterClasses,
    deleteMasterClasses,
    createMasterClass,
  } = useMasterClasses();

  const [focusedModule, setFocusedModule] = React.useState(-1);
  const [selection, setSelection] = useState([]);
  const [addMasterClassOpen, setAddMasterClassOpen] = useState(false);
  const [deleteMasterClassOpen, setDeleteMasterClassOpen] = useState(false);

  const {root} = useStyles();
  const query = useQuery(12);

  const actionsDisabled = isCreatingMasterClass || isDeletingMasterClasses;

  const createMasterClassChain = useCallback((form) => {
    return createMasterClass(form)
      .then(() => {
        setAddMasterClassOpen(false);
        query.refresh();
      }, () => {
        setAddMasterClassOpen(false);
        query.refresh();
      })
  }, [setAddMasterClassOpen, createMasterClass, query]);

  const deleteMasterClassesChain = useCallback(() => {
    return deleteMasterClasses(selection)
      .then(() => {
        setDeleteMasterClassOpen(false);
        query.refresh();
      }, () => {
        setDeleteMasterClassOpen(false);
        query.refresh();
      })
  }, [setDeleteMasterClassOpen, deleteMasterClasses, selection, query]);

  useEffect(() => {
    query.load();
  }, []);

  const TableRowClick = (e) => {
    const focusedModule = e ? e.key : -1;
    setFocusedModule(focusedModule);
  };

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteMasterClassOpen(!deleteMasterClassOpen);
  }, [deleteMasterClassOpen]);

  const showAddModal = useCallback(() => {
    setAddMasterClassOpen(!addMasterClassOpen)
  }, [addMasterClassOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
    ]
  }, [showDeleteModal, selection]);

  return (
    <div>
      <DeleteConfirmationModal
        modalText="Удалить выбранные мастер-классы?"
        open={deleteMasterClassOpen}
        onConfirm={deleteMasterClassesChain}
        handleClose={() => setDeleteMasterClassOpen(false)}
      />
      <AddMasterClassModal
        open={addMasterClassOpen}
        handleConfirm={createMasterClassChain}
        handleClose={() => setAddMasterClassOpen(false)}/>
      <Breadcrumbs items={items}/>
      <div className={root}>
        <QueryTable focusedId={focusedModule}
                    onRowClick={TableRowClick}
                    onSelectionChanged={TableSelectionChanged}
                    primaryActions={<AddButton onClick={showAddModal}/>}
                    secondaryActions={secondaryActions}
                    {...query} />
        <MasterClassDrawer
          handleDrawerClose={() => TableRowClick(null)}
          mcId={focusedModule}
          open={focusedModule !== -1}
        />
      </div>
    </div>
  );
};

export default MasterClassList;
